export var FormatMimeType;
(function (FormatMimeType) {
    FormatMimeType["PNG"] = "image/png";
    FormatMimeType["WEBP"] = "image/webp";
})(FormatMimeType || (FormatMimeType = {}));
//# sourceMappingURL=FormatMimeType.js.map